import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#tag" }),
    /*#__PURE__*/_createTextVNode(" Tag ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Used for marking and selection. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIRemovableTag = _resolveComponent("EUIRemovableTag")
  const _component_EUIEditDynamically = _resolveComponent("EUIEditDynamically")
  const _component_EUISizes = _resolveComponent("EUISizes")
  const _component_EUITheme = _resolveComponent("EUITheme")
  const _component_EUICheckableTag = _resolveComponent("EUICheckableTag")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIRemovableTag),
    _createVNode(_component_EUIEditDynamically),
    _createVNode(_component_EUISizes),
    _createVNode(_component_EUITheme),
    _createVNode(_component_EUICheckableTag)
  ], 64))
}